import React from 'react';
import styled, { css } from 'styled-components';

interface Props {
  checked: boolean;
  onChange?: (value: boolean) => void;
  disabled?: boolean;
}

const MyInputSwitch: React.FC<Props> = ({ checked, onChange, disabled }) => {
  const [focused, setFocused] = React.useState(false);

  return (
    <SwitchWrapper
      checked={checked}
      disabled={disabled}
      onClick={() => {
        if (!disabled && onChange) onChange(!checked);
      }}
    >
      <HiddenCheckbox
        checked={checked}
        disabled={disabled}
        onChange={() => onChange?.(!checked)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
      <Slider checked={checked} focused={focused} />
    </SwitchWrapper>
  );
};

export default MyInputSwitch;

const SwitchWrapper = styled.div<{ checked: boolean; disabled?: boolean }>`
  --switch-width: 30px;
  --circle-size: 12px;
  --padding-size: 2px;

  position: relative;
  display: inline-block;
  width: var(--switch-width);
  height: 16px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`;

const Slider = styled.span<{ checked: boolean; focused: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${(props) => (props.checked ? props.theme.colors.primaryOrange : '#ced4da')};
  border-radius: 999px;
  border: 0;
  transition: background-color 0.2s, box-shadow 0.2s;

  &::before {
    content: '';
    position: absolute;
    background: #fff;
    width: var(--circle-size);
    height: var(--circle-size);
    left: var(--padding-size);
    top: 50%;
    border-radius: 50%;
    transform: ${({ checked }) =>
      checked
        ? 'translateX(calc(var(--switch-width) - var(--circle-size) - 2 * var(--padding-size))) translateY(-50%)'
        : 'translateY(-50%)'};
    transition: transform 0.2s;
  }

  ${({ focused }) =>
    focused &&
    css`
      box-shadow: 0 0 0 0.2rem #fa865670;
      outline: none;
    `}

  &:hover {
    background: ${(props) =>
      props.checked ? props.theme.colors.elementsButtonHover : props.theme.colors.elementsInputBorder};
  }
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
`;
